import React from 'react';
import { cn } from '../../../components/ui/Button';

export type ClassTabId = 'alunos' | 'licoes';

interface ClassTabsProps {
  activeTab: ClassTabId;
  onChange: (tab: ClassTabId) => void;
}

const tabs: Array<{ id: ClassTabId; label: string }> = [
  { id: 'licoes', label: 'Lições' },
  { id: 'alunos', label: 'Alunos' },
];

const ClassTabs: React.FC<ClassTabsProps> = ({ activeTab, onChange }) => {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-1 shadow-sm">
      <div className="grid grid-cols-2 gap-1">
        {tabs.map((tab) => {
          const isActive = tab.id === activeTab;

          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => onChange(tab.id)}
              className={cn(
                'h-12 rounded-xl px-3 text-sm font-semibold transition-colors',
                isActive ? 'bg-primary text-white shadow-sm' : 'text-slate-600 hover:bg-slate-50'
              )}
            >
              {tab.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ClassTabs;
